import { styled } from '@mui/material/styles'
import { SnackbarProvider } from 'notistack'

export const StyledSnackbarProvider = styled(SnackbarProvider)(() => ({
    '&.SnackbarItem-variantError': {
      backgroundColor: '#F7AB7E',
      color: "#353C45",
    },
}));